/*
 * Кластеры PostgreSQL на главной со списком баз: базы — из IaC (initdb кластера и CR
 * Database CloudNativePG через API кластера), размер — из Prometheus кластера
 * (cnpg_pg_database_size_bytes), статус — из ArgoCD.
 */
import { Chip, Tooltip, Typography } from '@material-ui/core';
import { TableColumn } from '@backstage/core-components';
import { AsyncState } from 'react-use/esm/useAsync';
import { routes } from '../../lib/viva';
import { formatBytes } from '../../lib/prometheus';
import { ArgoAppsSummary } from '../argocd';
import { AsyncCell } from '../catalog/cells';
import { datastoreColumns } from '../catalog/columns';
import { DatabaseIcon } from '../icons';
import { ResourceCard } from './ResourceCard';
import { DatabaseRow, HomeDatabase, Resources } from './useResources';

const chipTitle = (db: HomeDatabase) => {
  if (db.applied === false)
    return `${db.name}: CR Database не применён оператором`;
  return db.bytes === undefined
    ? `${db.name}: размер неизвестен (Prometheus недоступен)`
    : `${db.name}: ${formatBytes(db.bytes)}`;
};

const chipLabel = (db: HomeDatabase) => {
  if (db.applied === false) return `${db.name} · ошибка`;
  return db.bytes === undefined
    ? db.name
    : `${db.name} · ${formatBytes(db.bytes)}`;
};

const DatabasesList = ({ databases }: { databases: HomeDatabase[] }) => {
  if (databases.length === 0) {
    return (
      <Typography variant="body2" color="textSecondary" noWrap>
        баз в IaC нет
      </Typography>
    );
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {databases.map(db => (
        <Tooltip key={db.name} title={chipTitle(db)}>
          <Chip
            size="small"
            color={db.applied === false ? 'secondary' : 'default'}
            label={chipLabel(db)}
            style={{ fontFamily: 'monospace' }}
          />
        </Tooltip>
      ))}
    </div>
  );
};

const base = datastoreColumns<DatabaseRow>('База данных', row => (
  <AsyncCell state={row.apps} unavailable="ArgoCD недоступен">
    {apps => <ArgoAppsSummary apps={apps ?? []} />}
  </AsyncCell>
));

// колонка «Базы» после адреса, перед ArgoCD
const columns: TableColumn<DatabaseRow>[] = [
  ...base.slice(0, 3),
  {
    title: 'Базы',
    sorting: false,
    render: row => (
      <AsyncCell state={row.databases} unavailable="API кластера недоступен">
        {databases => <DatabasesList databases={databases ?? []} />}
      </AsyncCell>
    ),
  },
  ...base.slice(3),
];

export const DatabasesCard = ({
  resources,
}: {
  resources: AsyncState<Resources>;
}) => (
  <ResourceCard<DatabaseRow>
    icon={<DatabaseIcon />}
    title="Базы данных"
    to={routes.databases}
    linkText="все базы"
    columns={columns}
    rows={resources.value?.databases}
    loading={resources.loading}
    error={resources.error}
    errorTitle="Не удалось загрузить базы данных"
    emptyText="Баз данных пока нет — создайте PostgreSQL из шаблона «Кластер PostgreSQL»."
    createText="Создать кластер PostgreSQL"
    createTo={routes.newPostgres}
  />
);
